import React from 'react'
import classNames from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

import mapStyle from "assets/jss/prehnit/components/mapStyle.jsx";

import { METERS_PER_UNIT } from "ol/proj/Units";

import { withNamespaces } from "react-i18next";
import numbro from 'numbro';

class MapScale extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      tempValue: '10000',
      open: false
    }

    this.dpiMeasure = null;

    this.dpiMeasureRef = element => {
      this.dpiMeasure = element
    };

    this._calculateDPI = this._calculateDPI.bind(this);
    this.getDPI = this.getDPI.bind(this);
    this.handleScaleClick = this.handleScaleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleClose = this.handleClose.bind(this);


  }

  getDPI() {
    // Returns the last cached DPI value.
    //
    if (!this.dpi) {
      this.dpi = this._calculateDPI();
    }
    return this.dpi;
  };

  _calculateDPI() {
    // Returns the DPI as calculated by the browser.
    //
    if (this.dpiMeasure) {
      var el = this.dpiMeasure;
      var ppi = window.devicePixelRatio || 1.0;
      var dpi = parseFloat(el.offsetWidth) * ppi;
      if (dpi <= 0) {
        dpi = 96;
      }
      return dpi;
    }

    return 96;

  };

  getMapScale(units, res, zoom) {

    let customScales = {
      "8": 2000000,
      "9": 1000000,
      "10": 500000,
      "11": 250000,
      "12": 150000,
      "13": 75000,
      "14": 50000,
      "15": 20000,
      "16": 10000,
      "17": 5000,
      "18": 2000
    }

    let zoomRounded = Math.round(zoom);
    let customScale = customScales[zoomRounded];
    return numbro(customScale).format({ mantissa: 0 });

    // console.log('Scaler', units, res);
    // Return map scale denominator, relying on dpi provided by the browser.
    //
    // if (this.state.value) {
    //   return this.state.value;
    // } else {
    // var dpi   = this.getDPI();
    // var mpu   = METERS_PER_UNIT[units];
    // var scale = res * mpu * 39.37 * dpi;

    // //console.log(zoom, res, Math.round(scale));
    // return numbro(Math.round(scale)).format({average: true, mantissa: 0});
    // }
  };

  setMapScale(units, scale) {
    // Sets the resolution using given "scale" denominator (1:x).
    //
    var dpi = this.getDPI();
    var mpu = METERS_PER_UNIT[units];
    var res = scale / (mpu * 39.37 * dpi);

    if (this.props.onChangeScale) {
      this.props.onChangeScale(res);
    }
  };

  handleScaleClick() {
    this.setState((state) => {
      return {
        open: true,
        tempValue: state.value
      }
    });
  }

  handleChange(e) {
    const regex = /^[0-9]+$/g
    const found = e.target.value.match(regex);
    if (found) {
      this.setState({
        tempValue: e.target.value
      })
    }
  };

  handleKeyDown(e) {
    const { projUnits } = this.props;

    if (e.key === 'Enter') {
      this.setState({
        open: false,
        value: e.target.value
      })
      if (this.props.onChangeScale) {
        var res = this.setMapScale(projUnits, e.target.value)
        this.props.onChangeScale(res);
      }
    } else if (e.key === "Escape") {
      this.setState({
        open: false
      })
    }
  }

  handleClose(e) {
    this.setState({
      open: false
    })
  }

  render() {
    const { t, classes, projUnits, viewResolution, zoom } = this.props;

    return (
      <div id="map-scale-container">
        <div id="temp_dpi_measure" ref={this.dpiMeasureRef} style={{ width: "1in" }} />
        <div id="map-scale" className={classNames(classes.dimTool, classes.mapScale)}>
          <ClickAwayListener onClickAway={this.handleClose} ref="cacat">
            <div>
              {t("map:scale")} ~ 1 : {this.state.open ?
                <input value={this.state.tempValue} className={classes.mapScaleInput} autoFocus
                  onChange={this.handleChange}
                  onKeyDown={this.handleKeyDown} />
                : <span onClick={this.handleScaleClick} className={classes.mapScaleLabel}>{this.getMapScale(projUnits, viewResolution, zoom)}</span>

              }
            </div>
          </ClickAwayListener>
        </div>
      </div>
    );
  }
}

export default withNamespaces()(withStyles(mapStyle)(MapScale));